import Accordion from 'LuxKit/Accordion'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import React from 'react'

export default function LoyaltyPrograms() {
  return (
    <Group direction="vertical" gap={8}>
      <Heading variant="heading4">Loyalty programs</Heading>
      <Accordion size="large" heading="How do I connect my corporate travel program (i.e. Qantas Business Rewards and Virgin Australia Business Flyer?">
        <BodyText variant="large">
          To connect your corporate travel program, such as Qantas Business Rewards or Virgin Australia Business Flyer, please follow these steps:
        </BodyText>
        <ol>
          <Group direction="vertical" gap={12}>
            <li>
              <BodyText variant="large" weight="bold">Access the Settings Page:</BodyText>
              <BodyText variant="large"> Log in to your Admin portal account and navigate to the Settings page.</BodyText>
            </li>
            <li>
              <BodyText variant="large" weight="bold">Navigate to Business Frequent Flyer Tab:</BodyText>
              <BodyText variant="large"> Within the settings page, locate and click on the 'Business Frequent Flyer' tab. This section is where you can manage connections to corporate travel programs.</BodyText>
            </li>
            <li>
              <BodyText variant="large" weight="bold">Send a Connection Request:</BodyText>
              <BodyText variant="large"> Once you are on the Business Frequent Flyer tab, find the option to send a request to our Customer Support team for assistance with connecting your corporate travel program. Click on this option to initiate the request.</BodyText>
            </li>
            <li>
              <BodyText variant="large" weight="bold">Wait for Assistance:</BodyText>
              <BodyText variant="large"> Our Customer Support team will process your request and assist you in connecting your corporate travel program to your Business Traveller account. They will guide you through the process and ensure that the connection is successfully established.</BodyText>
            </li>
            <li>
              <BodyText variant="large" weight="bold">Confirmation:</BodyText>
              <BodyText variant="large"> Once the connection is complete, you will receive confirmation from our Customer Support team. You can then begin leveraging the benefits and rewards offered through your corporate travel program within the Business Traveller platform.</BodyText>
            </li>
          </Group>
        </ol>
      </Accordion>
      <Accordion size="large" heading="How do I link up any corporate air agreements I have with specific airlines?">
        <BodyText variant="large">
          To link up any specific corporate air agreements you have with particular airlines, please follow these steps:
        </BodyText>
        <ol>
          <Group direction="vertical" gap={12}>
            <li>
              <BodyText variant="large" weight="bold">Contact Customer Support:</BodyText>
              <BodyText variant="large"> Reach out to our Customer Support team for assistance with linking your corporate air agreements to your Business Traveller account.</BodyText>
            </li>
            <li>
              <BodyText variant="large" weight="bold">Provide Details:</BodyText>
              <BodyText variant="large"> When contacting Customer Support, be prepared to provide details about the specific corporate air agreements you have in place, including the airlines involved and any relevant contract or agreement information. Our support team will guide you through the process and ensure that the necessary connections are established.</BodyText>
            </li>
            <li>
              <BodyText variant="large" weight="bold">Confirmation:</BodyText>
              <BodyText variant="large"> Once the linking process is complete, you will receive confirmation from our Customer Support team. You can then begin leveraging the benefits and privileges associated with your corporate air agreements when booking travel through Business Traveller.</BodyText>
            </li>
          </Group>
        </ol>
      </Accordion>
    </Group>
  )
}
